import { type LatLng } from "leaflet";

/**
 * 住所や地番など不動産の位置情報を統合的に管理するクラス
 */
export class AddressIntegrator {
  /** 都道府県名 */
  public prefName?: string;
  /** 市区町村名 */
  public cityName?: string;
  /** 大字名（存在しない場合はnull） */
  public ooazaName?: string | null;
  /** 字名（存在しない場合はnull） */
  public azaName?: string | null;
  /** 地番 */
  public chiban?: string;
  /** 住居表示 */
  public address?: string;
  /** 地番表記（登記簿上の表記） */
  public addressChiban?: string;
  /** 緯度経度 */
  public latlng?: LatLng | null;
  /** 面積（m²） */
  public area?: number | null;
  /** 追加のデータ */
  public attachedData?: unknown;

  /**
   * コンストラクタ
   * @param init 初期化オブジェクトまたは都道府県名
   * @param cityName 市区町村名（initが文字列の場合のみ使用）
   * @param chiban 地番（initが文字列の場合のみ使用）
   * @param address 住居表示（initが文字列の場合のみ使用）
   * @param addressChiban 地番表記（initが文字列の場合のみ使用）
   * @param latlng 緯度経度（initが文字列の場合のみ使用）
   * @param area 面積（initが文字列の場合のみ使用）
   * @param ooazaName 大字名（initが文字列の場合のみ使用）
   * @param azaName 字名（initが文字列の場合のみ使用）
   * @param attachedData 追加のデータ（initが文字列の場合のみ使用）
   */
  constructor(
    init: Partial<AddressIntegrator> | string = "",
    cityName = "",
    chiban = "",
    address = "",
    addressChiban = "",
    latlng: LatLng | null = null,
    area: number | null = null,
    ooazaName: string | null = null,
    azaName: string | null = null,
    attachedData: unknown | undefined = undefined
  ) {
    if (typeof init === "string") {
      // 従来の引数による初期化
      this.prefName = init;
      this.cityName = cityName;
      this.ooazaName = ooazaName;
      this.azaName = azaName;
      this.chiban = chiban;
      this.address = address;
      this.addressChiban = addressChiban;
      this.latlng = latlng;
      this.area = area;
      this.attachedData = attachedData;
    } else {
      // オブジェクトによる初期化
      Object.assign(this, init);
    }
  }

  /**
   * 所在地を構築する（市区町村名 + 大字名 + 字名）
   * @returns 所在地の文字列
   */
  public buildLocationFull(): string {
    const ooazaName = this.ooazaName ?? "";
    const azaName = this.azaName ?? "";
    return `${this.cityName ?? ""}${ooazaName}${azaName}`;
  }

  /**
   * フルアドレスを構築する（都道府県名 + 市区町村名 + 大字名 + 字名 + 地番）
   * @returns フルアドレスの文字列
   */
  public buildFullAddress(): string {
    return `${this.prefName ?? ""}${this.buildLocationFull()}${
      this.chiban ?? ""
    }`;
  }
}
